import { Package, Plane, Ship, Truck, Box } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const getModeIcon = (mode) => {
  const icons = { air: Plane, ocean: Ship, road: Truck };
  return icons[mode] || Box;
};

const EquipmentStats = ({ equipment, t }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      <Card className="border-l-4 border-l-navy-600">
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-steel-500">{t('equipmentMgmt.total')}</p>
              <p className="text-2xl font-bold text-navy-800">{equipment.length}</p>
            </div>
            <Package className="w-8 h-8 text-navy-600 opacity-50" />
          </div>
        </CardContent>
      </Card>
      {['air', 'ocean', 'road'].map(mode => {
        const count = equipment.filter(e => e.mode === mode).length;
        const Icon = getModeIcon(mode);
        return (
          <Card key={mode} className="border-l-4 border-l-gold">
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-steel-500 capitalize">{mode}</p>
                  <p className="text-2xl font-bold text-navy-800">{count}</p>
                </div>
                <Icon className="w-8 h-8 text-gold opacity-50" />
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default EquipmentStats;
